'use strict';

var ProgressBar = require('progressbar.js');
var progressCircles = {};
var circles;

var progressConfig = {
    color: '#69edff',
    strokeWidth: 8,
    duration: 1000,
    trailWidth: 8,
    trailColor: '#f7f7f0',
    text: {
        style: {
            color: '#FFFFFF',
        },
        value: '0'
    },
    step: function(state, bar) {
        bar.setText((bar.value() * 100).toFixed(0) + '%');
    }
};

module.exports = {

    init: function init() {
        circles = document.getElementsByClassName('progress-circle');

        //Setup circles
        Array.prototype.forEach.call(circles, function(circle, index) {
            progressCircles[index] = new ProgressBar.Circle(circle, progressConfig);
            circle.dataset.progressCircleIndex = index;
        });
    },

    animate: function animate() {
        Array.prototype.forEach.call(circles, function(circle) {
            var progressCircle = progressCircles[circle.dataset.progressCircleIndex];
            progressCircle.animate(circle.dataset.percent / 100);
        });
    }
};



// WEBPACK FOOTER //
// ./resources/js/components/circleProgressBars.js